/**
 * Dopuszczalne masy na osiach dla Mercedes Benz Tourist Line HighDeck
 * (Sekcja 16.2 / 17.2 - Technically permissible maximum mass on each axle) -
 * patrz iveco-axle-mass-limits.ts po strukturę i konwencje (typ AxleMassLimit
 * oraz uogólniona funkcja odczytująca dane, getAxleMassLimit, mieszkają w
 * vehicle-axle-mass-limits.ts (ten sam folder) - ten plik zawiera wyłącznie
 * dane specyficzne dla tej zabudowy).
 *
 * W przeciwieństwie do Iveco, źródło nie różnicuje wartości wg oznaczenia
 * skrzyni/napędu ({{baseVehicleVersion}}) - stąd wszystkie wpisy są pod
 * kluczem "*", tym samym wzorcem "brak drugiego wymiaru" co przy danych
 * masowych (patrz "*" w mercedes-tourist-line-highdeck-mass-data.ts).
 *
 * TODO: tonaż "72" (jeśli w ogóle występuje dla tej zabudowy) do uzupełnienia,
 * gdy pojawi się źródło.
 *
 * @module mercedes-tourist-line-highdeck-axle-mass-limits
 */

import type { AxleMassLimitTable } from "./vehicle-axle-mass-limits";

export const MERCEDES_TOURIST_LINE_HIGHDECK_AXLE_MASS_LIMITS: AxleMassLimitTable =
  {
    "68": {
      "*": { axle1: 2300, axle2: 5200 },
    },
    "62": {
      "*": { axle1: 2100, axle2: 4300 },
    },
  };
